export default class TabToggle {
  constructor() {
    this._activateFromHash()
    window.addEventListener('hashchange', () => this._activateFromHash())

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-tab-btn]')
      if (!btn) return

      const group = btn.closest('[data-tab-group]')
      if (!group) return

      const target = btn.dataset.tabBtn

      group.querySelectorAll('[data-tab-btn]').forEach((b) => {
        b.classList.remove('is-active')
      })

      btn.classList.add('is-active')

      group.querySelectorAll('[data-tab-panel]').forEach((panel) => {
        panel.style.display = panel.dataset.tabPanel === target ? '' : 'none'
      })
    })
  }

  _activateFromHash() {
    const hash = location.hash.slice(1)
    if (!hash) return
    document.querySelectorAll('[data-tab-group]').forEach((group) => {
      const btn = group.querySelector(`[data-tab-btn="${hash}"]`)
      if (!btn) return
      group
        .querySelectorAll('[data-tab-btn]')
        .forEach((b) => b.classList.remove('is-active'))
      btn.classList.add('is-active')
      group.querySelectorAll('[data-tab-panel]').forEach((panel) => {
        panel.style.display = panel.dataset.tabPanel === hash ? '' : 'none'
      })
    })
  }
}
